import Tooltip from "@material-ui/core/Tooltip";
import CancelIcon from "@material-ui/icons/Cancel";
import React from "react";
import { FunctionField, useTranslate } from "react-admin";
import { Link } from "react-router-dom";

const ICON_COLOR_HAS_DEVIATIONS = "#e74c3c";

const DeviationsLinkButton = ({ record }) => {
	const translate = useTranslate();
	if (!record.is_exists_deviations) return null;

	return (
		<Tooltip title={translate("tab.deviations.name")}>
			<Link
				to={`/orders/${record.id}/show/deviations`}
				onClick={(event) => event.stopPropagation()}
			>
				<CancelIcon
					style={{ fontSize: 20, verticalAlign: "middle", color: ICON_COLOR_HAS_DEVIATIONS }}
				/>
			</Link>
		</Tooltip>
	);
};

export const DeviationsLinkField = (props) => (
	<FunctionField
		{...props}
		align="center"
		render={(record) => <DeviationsLinkButton record={record} />}
	/>
);
